import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const InviteFriendsPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.InviteFriends,
  }))
);

export function InviteFriendsContainer() {
  return <LazyLoadComponent Component={<InviteFriendsPage />} />;
}
